import React from 'react';

import { useAppSelector } from '@/hooks';
import { createSelector } from '@reduxjs/toolkit';
import { Calendar } from '@/components/common';
import { AllShifts } from '@/components/agent/my-schedule';
import { selectIsSchedulesListLoading } from '@/store/selectors/scheduleSelectors';

const myScheduleCalendarSelector = createSelector(selectIsSchedulesListLoading, isSchedulesListLoading => ({
  isLoading: isSchedulesListLoading,
}));

interface IMyScheduleCalendarProps {
  containerRef: React.RefObject<HTMLDivElement>;
}

const MyScheduleCalendar = ({ containerRef }: IMyScheduleCalendarProps): React.ReactElement => {
  const { isLoading } = useAppSelector(myScheduleCalendarSelector);

  return <Calendar Weekday={AllShifts} containerRef={containerRef} isLoading={isLoading} />;
};

export { MyScheduleCalendar };
